import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { GLNService } from "src/app/core/services/gln/gln.service";
import { GLN } from "src/app/models/gln.model";

@Component({
  selector: 'show-gln',
  templateUrl: 'show-gln.component.html',
  styleUrls: ['show-gln.component.scss'],
  host: {
    '[class.creation]': 'create || gln && gln.status === "DRAFT"',
    '[class.created]': '!create && gln && gln.status !== "DRAFT"'
  }
})
export class ShowGLNComponent implements OnInit {
  subs: Subscription[] = [];
  edit = false;
  create = false;
  id!: string;
  gln?: GLN;

  constructor (private activatedRoute: ActivatedRoute, private glnService: GLNService, private router: Router) {}

  ngOnInit(): void {
    this.gln = undefined;

    // Set the initial state depending of the route
    if (this.activatedRoute.toString().indexOf('modifier') > -1) {
      this.edit = true;
    } else if (this.activatedRoute.toString().indexOf('creer') > -1) {
      this.create = true;
    }
    this.subs.push(this.activatedRoute.params.subscribe(params => {
      if (!!params['id']) {
        this.id = params['id'];
        this.loadGLN();
      } else {
        this.edit = true;
      }
    }));
  }


  /**
   * Loads the GLN object for the component id or number.
   * @returns None
   */
  async loadGLN() {
    try {
      if (this.id.length === 13 && !isNaN(Number(this.id))) {
        this.gln = new GLN(await this.glnService.getGlnByNumber(this.id));
      } else {
        this.gln = new GLN(await this.glnService.getGlnById(this.id));
      }
    } catch(err) {
      console.error(err)
    }
  }


  /**
   * Finishes editing the GLN.
   * @param {GLN} gln - the GLN object to edit.
   * @returns None
   */
  finishingEdit(gln: GLN) {
    this.gln = gln;
    this.edit = false;
    this.create = false;
  }

  startEdit() {
    this.edit = true;
  }
}
